import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import logo from '../images/logo.png';
import cTOne from '../images/s51logo.png';
import cTTwo from '../images/deloite.png';
import cTThree from '../images/berkshire.png';
import cTFour from '../images/Google.png';
import cTFive from '../images/pwc.jpg';
import cTSix from '../images/microsoft.png';
import cTSeven from '../images/sociazy-logo.jpg';
import cTEight from '../images/nervana-logo.jpg';
import nervanaLogo from '../images/nervana-logo.jpg';
import sociazyLogo from '../images/sociazy-logo.jpg';
import s51Logo from '../images/s51logo.png';
import bluBoxLogo from '../images/bluebox3.png';
import yourImage from '../images/testimonial-bg.png';
import portfolio1 from '../images/portfolio1.png';
import portfolio2 from '../images/portfolio2.png';
import portfolio3 from '../images/portfolio3.png';
import portfolio4 from '../images/portfolio4.png';
import portfolio5 from '../images/portfolio5.png';
import portfolio6 from '../images/portfolio6.png';
import portfolio8 from '../images/portfolio8.png';
import portfolio9 from '../images/portfolio9.png';
import portfolio10 from '../images/portfolio10.png';
import portfolio11 from '../images/portfolio11.png';
import portfolio12 from '../images/portfolio12.png';
import portfolio13 from '../images/portfolio13.png';
import portfolio14 from '../images/gaming0.png';
import {
  FaHome,
  FaFolderOpen,
  FaEnvelope,
  FaArrowUp,
  FaBullhorn,
  FaCode,
  FaChartLine,
  FaRobot,
  FaProjectDiagram,
  FaPaperPlane,
  FaUsers,
  FaSearch,
  FaComments,
  FaHandshake,
  FaArrowRight,
  FaArrowLeft
} from 'react-icons/fa';

const isMobile = window.innerWidth <= 768;

function Portfolio() {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);

  return (
    <div
      style={{
        backgroundColor: '#fff',
        minHeight: '100vh',
        width: '100%'
      }}
    >
      <section
        style={{
          width: '100%',
          height: '100vh',
          backgroundColor: '#fff',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          overflow: 'hidden',
          position: 'relative'
        }}
      >
        {/* Background Image */}
        <img
          src={yourImage}
          alt="Portfolio"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            position: 'absolute',
            top: 0,
            left: 0
          }}
        />

        {/* Header */}
        <section
          style={{
            height: '100px',
            background: 'transparent',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            padding: '20px 40px',
            zIndex: 1000
          }}
        >
          {/* Logo Left */}
          <motion.img
            src={logo}
            alt="Logo"
            onClick={() => navigate('/')}
            whileHover={{
              scale: 1.08
            }}
            transition={{
              duration: 0.25
            }}
            style={{
              height: '70px',
              objectFit: 'contain',
              cursor: 'pointer'
            }}
          />

          {/* Chat Button Right */}
          <motion.button
            onClick={() =>
              window.open(
                'https://www.linkedin.com/in/hritikatapadar/',
                '_blank',
                'noopener,noreferrer'
              )
            }
            whileHover={{
              scale: 1.08,
              boxShadow:
                '0 0 25px rgba(196,77,255,0.6), 0 0 50px rgba(255,77,141,0.3)'
            }}
            whileTap={{
              scale: 0.96
            }}
            transition={{
              duration: 0.25
            }}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              border: 'none',
              borderRadius: '50px',
              padding: '10px 20px 10px 10px',
              background:
                'linear-gradient(90deg, #ff4d8d, #c44dff, #ff4d4d)',
              color: '#fff',
              fontWeight: '700',
              fontSize: '16px',
              cursor: 'pointer'
            }}
          >
            <div
              style={{
                width: '36px',
                height: '36px',
                borderRadius: '50%',
                background: '#fff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#0A66C2',
                fontWeight: '900',
                fontSize: '18px'
              }}
            >
              in
            </div>

            Chat
          </motion.button>
        </section>

        {/* Portfolio Area */}
        <section
          style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'relative',
            zIndex: 10
          }}
        >

          {/* Left Click Zone */}
          <div
            onClick={() => {
              if (currentPage > 1) {
                setCurrentPage(currentPage - 1);
              }
            }}
            style={{
              position: 'absolute',

              left: isMobile ? 'calc(50% - 70px)' : 0,
              top: isMobile ? 'auto' : 0,
              bottom: isMobile ? '20px' : 'auto',

              width: isMobile ? '60px' : '17.5%',
              height: isMobile ? '60px' : '100%',

              cursor: currentPage > 1 ? 'pointer' : 'not-allowed',
              zIndex: 100,

              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <div
              style={{
                width: '60px',
                height: '60px',
                borderRadius: '50%',
                background: currentPage > 1
                  ? 'linear-gradient(135deg, #0F2027 0%, #275E76 50%, #4CA1AF 100%)'
                  : 'rgba(255,255,255,0.05)',
                backdropFilter: 'blur(5px)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: currentPage > 1
                  ? '0 8px 25px rgba(39, 94, 118, 0.5)'
                  : '0 4px 12px rgba(0,0,0,0.2)',
                transition: 'all 0.3s ease',
              }}
            >
              <FaArrowLeft
                style={{
                  color: currentPage > 1 ? '#fff' : '#999',
                  fontSize: '22px',
                }}
              />
            </div>
          </div>


          {/* Portfolio Box */}
          {/* Center Portfolio Box */}
          {/* Center Portfolio Box */}
          <div
            style={{
              width: isMobile ? '95%' : '95%',
              minHeight: isMobile ? 'auto' : '600px',
              padding: isMobile ? '20px' : '40px',
              borderRadius: isMobile ? '20px' : '30px',
              maxWidth: '1150px',

              background:
                'linear-gradient(135deg, #0f172a 0%, #4c1d95 50%, #7f1d1d 100%)',
              border: '2px solid rgba(255,255,255,0.08)',
              boxShadow:
                '0 0 40px rgba(196,77,255,0.65), 0 0 60px rgba(255,77,141,0.45)',
              backdropFilter: 'blur(10px)',
              WebkitBackdropFilter: 'blur(10px)',
              position: 'relative',
              zIndex: 2,
              margin: '0 auto',
            }}
          >

            {currentPage === 1 && (
              <div
                style={{
                  height: isMobile ? 'auto' : '420px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  gap: isMobile ? '20px' : '0'
                }}
              >

                {/* Presentation Heading */}
                <div
                  style={{
                    textAlign: 'center',
                    marginBottom: '10px'
                  }}
                >
                  <h1
                    style={{
                      color: '#fff',
                      fontSize: isMobile ? '28px' : '42px',
                      fontWeight: '900',
                      lineHeight: '1.05',
                      margin: 0,
                      letterSpacing: isMobile ? '0px' : '-1px'
                    }}
                  >
                    Corporate
                    <br />
                    Presentation
                  </h1>

                  <p
                    style={{
                      color: 'rgba(255,255,255,0.8)',
                      fontSize: isMobile ? '13px' : '16px',
                      fontWeight: '600',
                      marginTop: '18px',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      gap: isMobile ? '8px' : '15px',
                      flexWrap: 'wrap',
                      textAlign: 'center'
                    }}
                  >
                    <span>Expanding Visibility</span>

                    <span
                      style={{
                        color: '#ff4d8d',
                        fontWeight: '700'
                      }}
                    >
                      •
                    </span>

                    <span>Deepening Sales</span>

                    <span
                      style={{
                        color: '#c44dff',
                        fontWeight: '700'
                      }}
                    >
                      •
                    </span>

                    <span>Embracing Revenue</span>
                  </p>
                </div>

                {/* Website Button */}
                <div
                  style={{
                    textAlign: 'center',
                    marginBottom: '10px'
                  }}
                >
                  <motion.button
                    onClick={() =>
                      window.open(
                        'https://peregrinee.com',
                        '_blank',
                        'noopener,noreferrer'
                      )
                    }
                    whileHover={{
                      scale: 1.08,
                      boxShadow:
                        '0 0 25px rgba(255,255,255,0.25)'
                    }}
                    whileTap={{
                      scale: 0.96
                    }}
                    style={{
                      background: 'rgba(255,255,255,0.1)',
                      border: '1px solid rgba(255,255,255,0.2)',
                      color: '#fff',
                      borderRadius: '50px',
                      padding: isMobile ? '8px 18px' : '10px 24px',
                      fontWeight: '700',
                      cursor: 'pointer',
                      backdropFilter: 'blur(10px)',
                      fontSize: isMobile ? '13px' : '15px'
                    }}
                  >
                    www.peregrinee.com
                  </motion.button>
                </div>

                {/* Heading */}
                <h2
                  style={{
                    color: '#fff',
                    textAlign: 'center',
                    fontWeight: '800',
                    fontSize: isMobile ? '22px' : '28px',
                    marginBottom: '15px',
                    marginTop: '0'
                  }}
                >
                  Our Partners
                </h2>

                {/* Partner Logos */}
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns:
                      window.innerWidth < 768
                        ? 'repeat(2, 1fr)'
                        : 'repeat(4, 1fr)',
                    gap: '12px'
                  }}
                >
                  {[
                    ,
                    cTTwo,
                    cTThree,
                    cTFour,
                    cTFive,
                    cTSix,
                    cTSeven,
                    cTEight,
                    cTOne
                  ].map((partnerLogo, index) => (
                    <motion.div
                      key={index}
                      whileHover={{
                        scale: 1.08,
                        boxShadow:
                          '0 0 20px rgba(255,255,255,0.15)'
                      }}
                      transition={{
                        duration: 0.25
                      }}
                      style={{
                        background: '#fff',
                        borderRadius: isMobile ? '12px' : '16px',
                        padding: isMobile ? '10px' : '12px',
                        height: isMobile ? '70px' : '85px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        border: '2px solid rgba(0,251,255,0.99)',
                        cursor: 'pointer'
                      }}
                    >
                      <img
                        src={partnerLogo}
                        alt={`Partner ${index + 1}`}
                        style={{
                          maxWidth: '100%',
                          maxHeight: isMobile ? '40px' : '50px',
                          objectFit: 'contain'
                        }}
                      />
                    </motion.div>
                  ))}
                </div>

              </div>
            )}

            {/* {currentPage === 2 && (
              <div
                style={{
                  height: '420px',
                  position: 'relative'
                }}
              >

                <motion.button
                  onClick={() =>
                    window.open(
                      'https://peregrinee.com',
                      '_blank',
                      'noopener,noreferrer'
                    )
                  }
                  whileHover={{
                    scale: 1.1,
                    rotate: 45,
                    boxShadow: '0 0 20px rgba(255,255,255,0.3)'
                  }}
                  whileTap={{
                    scale: 0.95
                  }}
                  style={{
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    width: '55px',
                    height: '55px',
                    borderRadius: '50%',
                    border: 'none',
                    background:
                      'linear-gradient(135deg,#ff4d8d,#c44dff)',
                    color: '#fff',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 10
                  }}
                >
                  <FaArrowUp size={20} />
                </motion.button>

               
                <div
                  style={{
                    position: 'absolute',
                    right: '-85px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '12px',
                    zIndex: 10
                  }}
                >
                  <motion.button
                    onClick={() =>
                      window.open(
                        'https://peregrinee.com',
                        '_blank',
                        'noopener,noreferrer'
                      )
                    }
                    whileHover={{
                      scale: 1.08,
                      x: -5
                    }}
                    style={{
                      width: '70px',
                      height: '70px',
                      borderRadius: '18px',
                      border: 'none',
                      background: '#222',
                      color: '#fff',
                      cursor: 'pointer',
                      fontSize: '12px',
                      fontWeight: '700',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '6px',
                    }}
                  >
                    <FaHome size={22} />
                    Home
                  </motion.button>

                  <motion.button
                    whileHover={{
                      scale: 1.08,
                      x: -5
                    }}
                    style={{
                      width: '70px',
                      height: '70px',
                      borderRadius: '18px',
                      border: 'none',
                      background: '#222',
                      color: '#fff',
                      cursor: 'pointer',
                      fontSize: '12px',
                      fontWeight: '700',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '6px',
                    }}
                  >
                    <FaFolderOpen size={22} />
                    Work
                  </motion.button>

                  <motion.button
                    whileHover={{
                      scale: 1.08,
                      x: -5
                    }}
                    style={{
                      width: '70px',
                      height: '70px',
                      borderRadius: '18px',
                      border: 'none',
                      background: '#222',
                      color: '#fff',
                      cursor: 'pointer',
                      fontSize: '12px',
                      fontWeight: '700',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '6px',
                    }}
                  >
                    <FaEnvelope size={22} />
                    Contact
                  </motion.button>
                </div>

                
                <div
                  style={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}
                >
                  <div
                    style={{
                      textAlign: 'center'
                    }}
                  >
                    <h2
                      style={{
                        color: 'rgba(255,255,255,0.75)',
                        fontWeight: '700',
                        marginBottom: '10px'
                      }}
                    >
                      Video Coming Soon
                    </h2>

                    <p
                      style={{
                        color: 'rgba(255,255,255,0.45)',
                        margin: 0
                      }}
                    >
                      Showcase video will appear here.
                    </p>
                  </div>
                </div>

              </div>
            )} */}

            {currentPage === 2 && (

              <div
                style={{
                  height: isMobile ? '180px' : '550px',
                  position: 'relative',
                  overflow: 'visible',
                  borderRadius: isMobile ? '15px' : '20px',
                  background: 'transparent',
                }}
              >

                {/* Background Image */}
                <img
                  src={portfolio6}
                  alt="Portfolio Slide"
                  style={{
                    position: 'absolute',
                    inset: 0,
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    zIndex: 0,
                    borderRadius: isMobile ? '15px' : '20px'
                  }}
                />

                {/* Top Right Circular Button */}
                <motion.button
                  onClick={() =>
                    window.open(
                      'https://peregrinee.com',
                      '_blank',
                      'noopener,noreferrer'
                    )
                  }
                  whileHover={{
                    scale: 1.1,
                    rotate: 45,
                    boxShadow: '0 0 20px rgba(255,255,255,0.3)'
                  }}
                  whileTap={{
                    scale: 0.95
                  }}
                  style={{
                    position: 'absolute',
                    top: isMobile ? '10px' : '15px',
                    right: isMobile ? '10px' : '15px',
                    width: isMobile ? '42px' : '55px',
                    height: isMobile ? '42px' : '55px',
                    borderRadius: '50%',
                    border: 'none',
                    background:
                      'linear-gradient(135deg,#ff4d8d,#c44dff)',
                    color: '#fff',
                    fontSize: isMobile ? '18px' : '24px',
                    cursor: 'pointer',
                    fontWeight: 'bold',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 10
                  }}
                >
                  <FaArrowUp size={isMobile ? 16 : 20} />
                </motion.button>

                {/* Right Sticky Buttons */}
                <div
                  style={{
                    position: 'absolute',
                    right: isMobile ? '50%' : '-85px',
                    bottom: isMobile ? '10px' : 'auto',
                    top: isMobile ? '130%' : '50%',
                    transform: isMobile
                      ? 'translateX(50%)'
                      : 'translateY(-50%)',
                    display: 'flex',
                    flexDirection: isMobile ? 'row' : 'column',
                    gap: isMobile ? '8px' : '12px',
                    zIndex: 20
                  }}
                >

                  {/* Home */}
                  <motion.button
                    onClick={() =>
                      window.open(
                        'https://peregrinee.com',
                        '_blank',
                        'noopener,noreferrer'
                      )
                    }
                    whileHover={{
                      scale: 1.08,
                      x: isMobile ? 0 : -5
                    }}
                    style={{
                      width: isMobile ? '55px' : '70px',
                      height: isMobile ? '55px' : '70px',
                      borderRadius: isMobile ? '14px' : '18px',
                      border: 'none',
                      background: '#222',
                      color: '#fff',
                      cursor: 'pointer',
                      fontSize: isMobile ? '9px' : '12px',
                      fontWeight: '700',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: isMobile ? '3px' : '6px',
                    }}
                  >
                    <FaHome size={isMobile ? 16 : 22} />
                    Home
                  </motion.button>

                  {/* Work */}
                  <motion.button
                    onClick={() =>
                      window.open(
                        'https://www.peregrinee.com/case-studies',
                        '_blank',
                        'noopener,noreferrer'
                      )
                    }
                    whileHover={{
                      scale: 1.08,
                      x: isMobile ? 0 : -5
                    }}
                    style={{
                      width: isMobile ? '55px' : '70px',
                      height: isMobile ? '55px' : '70px',
                      borderRadius: isMobile ? '14px' : '18px',
                      border: 'none',
                      background: '#222',
                      color: '#fff',
                      cursor: 'pointer',
                      fontSize: isMobile ? '9px' : '12px',
                      fontWeight: '700',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: isMobile ? '3px' : '6px',
                    }}
                  >
                    <FaFolderOpen size={isMobile ? 16 : 22} />
                    Work
                  </motion.button>

                  {/* Contact */}
                  <motion.button
                    onClick={() =>
                      window.open(
                        'https://www.peregrinee.com/contact-us',
                        '_blank',
                        'noopener,noreferrer'
                      )
                    }
                    whileHover={{
                      scale: 1.08,
                      x: isMobile ? 0 : -5
                    }}
                    style={{
                      width: isMobile ? '55px' : '70px',
                      height: isMobile ? '55px' : '70px',
                      borderRadius: isMobile ? '14px' : '18px',
                      border: 'none',
                      background: '#222',
                      color: '#fff',
                      cursor: 'pointer',
                      fontSize: isMobile ? '9px' : '12px',
                      fontWeight: '700',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: isMobile ? '3px' : '6px',
                    }}
                  >
                    <FaEnvelope size={isMobile ? 16 : 22} />
                    Contact
                  </motion.button>

                </div>

              </div>

            )}

            {currentPage === 3 && (
              <div
                style={{
                  height: isMobile ? '550px' : '500px',
                  position: 'relative',
                  overflow: 'visible',
                  borderRadius: '20px',
                  background: 'transparent',
                  paddingBottom: isMobile ? '80px' : '0'
                }}
              >
                {/* Top Right Circular Button */}
                <motion.button
                  onClick={() =>
                    window.open(
                      'https://peregrinee.com',
                      '_blank',
                      'noopener,noreferrer'
                    )
                  }
                  whileHover={{
                    scale: 1.1,
                    rotate: 45,
                    boxShadow: '0 0 20px rgba(255,255,255,0.3)'
                  }}
                  whileTap={{
                    scale: 0.95
                  }}
                  style={{
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    width: '55px',
                    height: '55px',
                    borderRadius: '50%',
                    border: 'none',
                    background:
                      'linear-gradient(135deg,#ff4d8d,#c44dff)',
                    color: '#fff',
                    fontSize: '24px',
                    cursor: 'pointer',
                    fontWeight: 'bold',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <FaArrowUp size={20} />
                </motion.button>

                {/* Right Sticky Buttons */}
                <div
                  style={{
                    position: 'absolute',
                    right: '-85px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '12px'
                  }}
                >
                  {/* Home */}
                  <motion.button
                    onClick={() =>
                      window.open(
                        'https://peregrinee.com',
                        '_blank',
                        'noopener,noreferrer'
                      )
                    }
                    whileHover={{
                      scale: 1.08,
                      x: -5
                    }}
                    style={{
                      width: '70px',
                      height: '70px',
                      borderRadius: '18px',
                      border: 'none',
                      background: '#222',
                      color: '#fff',
                      cursor: 'pointer',
                      fontSize: '12px',
                      fontWeight: '700',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '6px',
                    }}
                  >
                    <FaHome size={22} />
                    Home
                  </motion.button>

                  {/* Placeholder Button 2 */}
                  <motion.button
                    onClick={() =>
                      window.open(
                        'https://www.peregrinee.com/case-studies',
                        '_blank',
                        'noopener,noreferrer'
                      )
                    }
                    whileHover={{
                      scale: 1.08,
                      x: -5
                    }}
                    style={{
                      width: '70px',
                      height: '70px',
                      borderRadius: '18px',
                      border: 'none',
                      background: '#222',
                      color: '#fff',
                      cursor: 'pointer',
                      fontSize: '12px',
                      fontWeight: '700',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '6px',
                    }}
                  >
                    <FaFolderOpen size={22} />
                    Work
                  </motion.button>

                  {/* Placeholder Button 3 */}
                  <motion.button
                    onClick={() =>
                      window.open(
                        'https://www.peregrinee.com/contact-us',
                        '_blank',
                        'noopener,noreferrer'
                      )
                    }
                    whileHover={{
                      scale: 1.08,
                      x: -5
                    }}
                    style={{
                      width: '70px',
                      height: '70px',
                      borderRadius: '18px',
                      border: 'none',
                      background: '#222',
                      color: '#fff',
                      cursor: 'pointer',
                      fontSize: '12px',
                      fontWeight: '700',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '6px',
                    }}
                  >
                    <FaEnvelope size={22} />
                    Contact
                  </motion.button>
                </div>

                {/* Page Content */}
                <div
                  style={{
                    height: '100%',
                    display: 'flex',
                    flexDirection: isMobile ? 'column' : 'row',
                    alignItems: 'center',
                    gap: isMobile ? '20px' : '50px',
                    paddingTop: isMobile ? '60px' : '0'
                  }}
                >

                  {/* Left Content */}
                  <div
                    style={{
                      flex: 1,
                      width: isMobile ? '100%' : 'auto',
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      paddingRight: isMobile ? '0' : '20px'
                    }}
                  >
                    <h1
                      style={{
                        color: '#fff',
                        fontSize: isMobile ? '32px' : '48px',
                        fontWeight: '900',
                        lineHeight: '1',
                        marginBottom: '18px',
                        textAlign: isMobile ? 'center' : 'left'
                      }}
                    >
                      HELLO!
                    </h1>

                    <div
                      style={{
                        marginBottom: '18px'
                      }}
                    >
                      <h5
                        style={{
                          color: '#4ADE80',
                          fontWeight: '700',
                          marginBottom: '4px',
                          lineHeight: '1.2',
                          fontSize: isMobile ? '13px' : '15px'
                        }}
                      >
                        We are Peregrinee.
                        <br />
                        A strategic partner in building high-value sales pipelines
                        for B2B, service, and technology-led brands.
                      </h5>

                      <p
                        style={{
                          color: '#ccc',
                          margin: 0,
                          lineHeight: '1.25',
                          fontSize: isMobile ? '12px' : '13px'
                        }}
                      >
                        We create a steady flow of people ready to talk business.
                        Because growth doesn’t come from being seen by everyone.
                        It comes from being in front of the right buyers at the right time.
                      </p>
                    </div>

                    <div
                      style={{
                        marginBottom: '18px'
                      }}
                    >
                      <h5
                        style={{
                          color: '#60A5FA',
                          fontWeight: '700',
                          marginBottom: '4px',
                          lineHeight: '1.2',
                          fontSize: isMobile ? '13px' : '15px'
                        }}
                      >
                        Most outreach gets ignored.
                        Most leads never convert.
                      </h5>

                      <p
                        style={{
                          color: '#ccc',
                          margin: 0,
                          lineHeight: '1.25',
                          fontSize: isMobile ? '12px' : '13px'
                        }}
                      >
                        We fix that by turning cold outreach into warm conversations
                        and warm conversations into qualified opportunities.
                      </p>
                    </div>

                    <div
                      style={{
                        marginBottom: '18px'
                      }}
                    >
                      <h5
                        style={{
                          color: '#F472B6',
                          fontWeight: '700',
                          marginBottom: '4px',
                          lineHeight: '1.2',
                          fontSize: isMobile ? '13px' : '15px'
                        }}
                      >
                        Stop Chasing Leads
                      </h5>

                      <p
                        style={{
                          color: '#ccc',
                          margin: 0,
                          lineHeight: '1.25',
                          fontSize: isMobile ? '12px' : '13px'
                        }}
                      >
                        You're not chasing prospects.
                        You're speaking directly to decision-makers who are ready to buy.
                      </p>
                    </div>

                    <div>
                      <h5
                        style={{
                          color: '#FBBF24',
                          fontWeight: '700',
                          marginBottom: '4px',
                          lineHeight: '1.2',
                          fontSize: isMobile ? '13px' : '15px'
                        }}
                      >
                        What We Build
                      </h5>

                      <p
                        style={{
                          color: '#ccc',
                          margin: 0,
                          lineHeight: '1.25',
                          fontSize: isMobile ? '12px' : '13px'
                        }}
                      >
                        A pipeline that fills.
                        Conversations that convert.
                        Revenue that compounds.
                      </p>
                    </div>
                  </div>

                  {/* Right Content */}
                  <div
                    style={{
                      flex: 1,
                      width: isMobile ? '100%' : 'auto',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center'
                    }}
                  >
                    <img
                      src={portfolio14}
                      alt="Business Animation"
                      style={{
                        width: '130%',
                        maxWidth: isMobile ? '250px' : '500px',
                        objectFit: 'contain'
                      }}
                    />
                  </div>

                </div>

              </div>
            )}


            {currentPage === 4 && (

              <div
                style={{
                  height: isMobile ? '550px' : '550px',
                  maxHeight: isMobile ? '550px' : 'none',
                  overflowY: isMobile ? 'auto' : 'visible',
                  overflowX: 'hidden',
                  position: 'relative',
                  paddingBottom: isMobile ? '80px' : '0',

                  scrollbarWidth: 'none', // Firefox
                  msOverflowStyle: 'none', // IE & Edge
                  WebkitOverflowScrolling: 'touch'
                }}
                className="hide-scrollbar"
              >

                {/* Top Right Circular Button */}
                <motion.button
                  onClick={() =>
                    window.open(
                      'https://peregrinee.com',
                      '_blank',
                      'noopener,noreferrer'
                    )
                  }
                  whileHover={{
                    scale: 1.1,
                    rotate: 45,
                    boxShadow: '0 0 20px rgba(255,255,255,0.3)'
                  }}
                  whileTap={{
                    scale: 0.95
                  }}
                  style={{
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    width: '55px',
                    height: '55px',
                    borderRadius: '50%',
                    border: 'none',
                    background:
                      'linear-gradient(135deg,#ff4d8d,#c44dff)',
                    color: '#fff',
                    fontSize: '24px',
                    cursor: 'pointer',
                    fontWeight: 'bold',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <FaArrowUp size={20} />
                </motion.button>

                {/* Right Sticky Buttons */}
                <div
                  style={{
                    position: 'absolute',
                    right: '-85px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '12px'
                  }}
                >
                  {/* Home */}
                  <motion.button
                    onClick={() =>
                      window.open(
                        'https://peregrinee.com',
                        '_blank',
                        'noopener,noreferrer'
                      )
                    }
                    whileHover={{
                      scale: 1.08,
                      x: -5
                    }}
                    style={{
                      width: '70px',
                      height: '70px',
                      borderRadius: '18px',
                      border: 'none',
                      background: '#222',
                      color: '#fff',
                      cursor: 'pointer',
                      fontSize: '12px',
                      fontWeight: '700',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '6px',
                    }}
                  >
                    <FaHome size={22} />
                    Home
                  </motion.button>

                  {/* Placeholder Button 2 */}
                  <motion.button
                    onClick={() =>
                      window.open(
                        'https://www.peregrinee.com/case-studies',
                        '_blank',
                        'noopener,noreferrer'
                      )
                    }
                    whileHover={{
                      scale: 1.08,
                      x: -5
                    }}
                    style={{
                      width: '70px',
                      height: '70px',
                      borderRadius: '18px',
                      border: 'none',
                      background: '#222',
                      color: '#fff',
                      cursor: 'pointer',
                      fontSize: '12px',
                      fontWeight: '700',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '6px',
                    }}
                  >
                    <FaFolderOpen size={22} />
                    Work
                  </motion.button>

                  {/* Placeholder Button 3 */}
                  <motion.button
                    onClick={() =>
                      window.open(
                        'https://www.peregrinee.com/contact-us',
                        '_blank',
                        'noopener,noreferrer'
                      )
                    }
                    whileHover={{
                      scale: 1.08,
                      x: -5
                    }}
                    style={{
                      width: '70px',
                      height: '70px',
                      borderRadius: '18px',
                      border: 'none',
                      background: '#222',
                      color: '#fff',
                      cursor: 'pointer',
                      fontSize: '12px',
                      fontWeight: '700',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '6px',
                    }}
                  >
                    <FaEnvelope size={22} />
                    Contact
                  </motion.button>
                </div>

                {/* Heading */}
                <div
                  style={{
                    marginBottom: isMobile ? '20px' : '15px',
                    textAlign: isMobile ? 'center' : 'left'
                  }}
                >
                  <h1
                    style={{
                      color: '#fff',
                      fontSize: isMobile ? '24px' : '34px',
                      fontWeight: '900',
                      marginBottom: '6px'
                    }}
                  >
                    WHAT WE DO
                  </h1>

                  <p
                    style={{
                      color: '#bdbdbd',
                      fontSize: isMobile ? '12px' : '15px',
                      lineHeight: '1.4',
                      maxWidth: '700px',
                      margin: isMobile ? '0 auto' : '0'
                    }}
                  >
                    We help brands build sales pipelines that consistently connect them
                    with the right buyers and convert intent into revenue.
                  </p>
                </div>

                {/* Service Boxes */}
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: isMobile ? '1fr' : 'repeat(3,1fr)',
                    gap: isMobile ? '15px' : '12px'
                  }}
                >
                  {/* Box 1 */}
                  <motion.div
                    whileHover={{
                      scale: 1.03,
                      boxShadow: '0 0 20px rgba(74,222,128,0.35)'
                    }}
                    style={{
                      border: '1px solid #1D5C39',
                      borderRadius: '18px',
                      padding: '15px',
                      background: '#0F2E1D'
                    }}
                  >
                    <FaProjectDiagram size={isMobile ? 22 : 26} color="#4ADE80" />

                    <h5
                      style={{
                        color: '#7CFFB2',
                        marginTop: '10px',
                        fontSize: isMobile ? '15px' : '16px'
                      }}
                    >
                      Pipeline Engine
                    </h5>

                    <ul
                      style={{
                        color: '#D8FBE5',
                        fontSize: isMobile ? '11px' : '14px',
                        paddingLeft: '18px',
                        lineHeight: '1.6'
                      }}
                    >
                      <li>Appointment Setting</li>
                      <li>Buyer Conversations</li>
                      <li>Sales Pipeline Building</li>
                      <li>Meeting Generation</li>
                    </ul>
                  </motion.div>

                  {/* Box 2 */}
                  <motion.div
                    whileHover={{
                      scale: 1.03,
                      boxShadow: '0 0 20px rgba(96,165,250,0.35)'
                    }}
                    style={{
                      border: '1px solid #285A9B',
                      borderRadius: '18px',
                      padding: '15px',
                      background: '#10253F'
                    }}
                  >
                    <FaPaperPlane size={isMobile ? 22 : 26} color="#60A5FA" />

                    <h5
                      style={{
                        color: '#7DB9FF',
                        marginTop: '10px',
                        fontSize: isMobile ? '15px' : '16px'
                      }}
                    >
                      Outreach Systems
                    </h5>

                    <ul
                      style={{
                        color: '#DCEBFF',
                        fontSize: isMobile ? '11px' : '14px',
                        paddingLeft: '18px',
                        lineHeight: '1.6'
                      }}
                    >
                      <li>LinkedIn Outreach</li>
                      <li>Email Outreach</li>
                      <li>WhatsApp Activation</li>
                      <li>Multi-Channel Sequences</li>
                    </ul>
                  </motion.div>

                  {/* Box 3 */}
                  <motion.div
                    whileHover={{
                      scale: 1.03,
                      boxShadow: '0 0 20px rgba(244,114,182,0.35)'
                    }}
                    style={{
                      border: '1px solid #7B2F63',
                      borderRadius: '18px',
                      padding: '15px',
                      background: '#3A1830'
                    }}
                  >
                    <FaUsers size={isMobile ? 22 : 26} color="#F472B6" />

                    <h5
                      style={{
                        color: '#FF9DCE',
                        marginTop: '10px',
                        fontSize: isMobile ? '15px' : '16px'
                      }}
                    >
                      Execution
                    </h5>

                    <ul
                      style={{
                        color: '#FFE1F0',
                        fontSize: isMobile ? '11px' : '14px',
                        paddingLeft: '18px',
                        lineHeight: '1.6'
                      }}
                    >
                      <li>BD Team Deployment</li>
                      <li>Human Conversations</li>
                      <li>Follow Ups</li>
                      <li>Optimization</li>
                    </ul>
                  </motion.div>

                  {/* Box 4 */}
                  <motion.div
                    whileHover={{
                      scale: 1.03,
                      boxShadow: '0 0 20px rgba(251,191,36,0.35)'
                    }}
                    style={{
                      border: '1px solid #8A6A15',
                      borderRadius: '18px',
                      padding: '15px',
                      background: '#3D2F0D'
                    }}
                  >
                    <FaSearch size={isMobile ? 22 : 26} color="#FBBF24" />

                    <h5
                      style={{
                        color: '#FFD86B',
                        marginTop: '10px',
                        fontSize: isMobile ? '15px' : '16px'
                      }}
                    >
                      Intelligence
                    </h5>

                    <ul
                      style={{
                        color: '#FFF1C4',
                        fontSize: isMobile ? '11px' : '14px',
                        paddingLeft: '18px',
                        lineHeight: '1.6'
                      }}
                    >
                      <li>ICP Analysis</li>
                      <li>Market Research</li>
                      <li>Buyer Mapping</li>
                      <li>List Building</li>
                    </ul>
                  </motion.div>

                  {/* Box 5 */}
                  <motion.div
                    whileHover={{
                      scale: 1.03,
                      boxShadow: '0 0 20px rgba(168,85,247,0.35)'
                    }}
                    style={{
                      border: '1px solid #5D35A5',
                      borderRadius: '18px',
                      padding: '15px',
                      background: '#28153F'
                    }}
                  >
                    <FaComments size={isMobile ? 22 : 26} color="#A855F7" />

                    <h5
                      style={{
                        color: '#CDA7FF',
                        marginTop: '10px',
                        fontSize: isMobile ? '15px' : '16px'
                      }}
                    >
                      Messaging
                    </h5>

                    <ul
                      style={{
                        color: '#EEE2FF',
                        fontSize: isMobile ? '11px' : '14px',
                        paddingLeft: '18px',
                        lineHeight: '1.6'
                      }}
                    >
                      <li>Offer Positioning</li>
                      <li>Conversation Scripts</li>
                      <li>Personalization</li>
                      <li>Response Handling</li>
                    </ul>
                  </motion.div>

                  {/* Box 6 */}
                  <motion.div
                    whileHover={{
                      scale: 1.03,
                      boxShadow: '0 0 20px rgba(239,68,68,0.35)'
                    }}
                    style={{
                      border: '1px solid #A33232',
                      borderRadius: '18px',
                      padding: '15px',
                      background: '#3B1717'
                    }}
                  >
                    <FaHandshake size={isMobile ? 22 : 26} color="#EF4444" />

                    <h5
                      style={{
                        color: '#FF9D9D',
                        marginTop: '10px',
                        fontSize: isMobile ? '15px' : '16px'
                      }}
                    >
                      Conversion Layer
                    </h5>

                    <ul
                      style={{
                        color: '#FFE0E0',
                        fontSize: isMobile ? '11px' : '14px',
                        paddingLeft: '18px',
                        lineHeight: '1.6'
                      }}
                    >
                      <li>Lead Qualification</li>
                      <li>Intent Filtering</li>
                      <li>Meeting Handover</li>
                      <li>Sales Support</li>
                    </ul>
                  </motion.div>
                </div>

              </div>
            )}

            {currentPage === 5 && (

              <div
                style={{
                  height: isMobile ? '70vh' : '450px',
                  maxHeight: isMobile ? '70vh' : '450px',
                  overflowY: isMobile ? 'auto' : 'visible',
                  overflowX: 'hidden',
                  position: 'relative',
                  paddingBottom: isMobile ? '90px' : '0',
                  WebkitOverflowScrolling: 'touch'
                }}
              >

                {/* Top Right Circular Button */}
                <motion.button
                  onClick={() =>
                    window.open(
                      'https://peregrinee.com',
                      '_blank',
                      'noopener,noreferrer'
                    )
                  }
                  whileHover={{
                    scale: 1.1,
                    rotate: 45,
                    boxShadow: '0 0 20px rgba(255,255,255,0.3)'
                  }}
                  whileTap={{
                    scale: 0.95
                  }}
                  style={{
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    width: '55px',
                    height: '55px',
                    borderRadius: '50%',
                    border: 'none',
                    background:
                      'linear-gradient(135deg,#ff4d8d,#c44dff)',
                    color: '#fff',
                    fontSize: '24px',
                    cursor: 'pointer',
                    fontWeight: 'bold',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <FaArrowUp size={20} />
                </motion.button>

                {/* Right Sticky Buttons */}
                <div
                  style={{
                    position: 'absolute',
                    right: '-85px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '12px'
                  }}
                >
                  {/* Home */}
                  <motion.button
                    onClick={() =>
                      window.open(
                        'https://peregrinee.com',
                        '_blank',
                        'noopener,noreferrer'
                      )
                    }
                    whileHover={{
                      scale: 1.08,
                      x: -5
                    }}
                    style={{
                      width: '70px',
                      height: '70px',
                      borderRadius: '18px',
                      border: 'none',
                      background: '#222',
                      color: '#fff',
                      cursor: 'pointer',
                      fontSize: '12px',
                      fontWeight: '700',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '6px',
                    }}
                  >
                    <FaHome size={22} />
                    Home
                  </motion.button>

                  {/* Placeholder Button 2 */}
                  <motion.button
                    onClick={() =>
                      window.open(
                        'https://www.peregrinee.com/case-studies',
                        '_blank',
                        'noopener,noreferrer'
                      )
                    }
                    whileHover={{
                      scale: 1.08,
                      x: -5
                    }}
                    style={{
                      width: '70px',
                      height: '70px',
                      borderRadius: '18px',
                      border: 'none',
                      background: '#222',
                      color: '#fff',
                      cursor: 'pointer',
                      fontSize: '12px',
                      fontWeight: '700',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '6px',
                    }}
                  >
                    <FaFolderOpen size={22} />
                    Work
                  </motion.button>

                  {/* Placeholder Button 3 */}
                  <motion.button
                    onClick={() =>
                      window.open(
                        'https://www.peregrinee.com/contact-us',
                        '_blank',
                        'noopener,noreferrer'
                      )
                    }
                    whileHover={{
                      scale: 1.08,
                      x: -5
                    }}
                    style={{
                      width: '70px',
                      height: '70px',
                      borderRadius: '18px',
                      border: 'none',
                      background: '#222',
                      color: '#fff',
                      cursor: 'pointer',
                      fontSize: '12px',
                      fontWeight: '700',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '6px',
                    }}
                  >
                    <FaEnvelope size={22} />
                    Contact
                  </motion.button>
                </div>

                {/* Heading */}
                {/* Heading 1 */}
                <div
                  style={{
                    marginBottom: '12px',
                    textAlign: isMobile ? 'center' : 'left'
                  }}
                >
                  <h1
                    style={{
                      color: '#fff',
                      fontSize: isMobile ? '22px' : '28px',
                      fontWeight: '900',
                      marginBottom: '4px'
                    }}
                  >
                    WHO WE ARE FOR
                  </h1>

                  <p
                    style={{
                      color: '#bdbdbd',
                      fontSize: isMobile ? '11px' : '14px',
                      lineHeight: '1.5',
                      margin: 0
                    }}
                  >
                    We work with B2B, tech, AI, agencies, consultants,
                    financial firms, and service-led brands that rely on
                    reaching the right buyers to build consistent sales pipelines.
                  </p>
                </div>

                {/* Heading 2 */}
                <div
                  style={{
                    marginBottom: '12px'
                  }}
                >
                  <h2
                    style={{
                      color: '#fff',
                      fontSize: isMobile ? '20px' : '24px',
                      fontWeight: '800',
                      marginBottom: '4px'
                    }}
                  >
                    BRANDS WE WORK WITH
                  </h2>

                  <p
                    style={{
                      color: '#bdbdbd',
                      fontSize: '14px',
                      lineHeight: '1.4',
                      margin: 0
                    }}
                  >
                    Trusted by international teams across AI, SaaS,
                    data, and enterprise services.
                  </p>
                </div>

                {/* Brand Grid */}
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: isMobile ? '1fr' : 'repeat(2,1fr)',
                    gap: '12px',
                    marginTop: '15px'
                  }}
                >

                  {/* Box 1 - Nervana */}
                  <motion.div
                    whileHover={{
                      scale: 1.02,
                      boxShadow: '0 0 20px rgba(74,222,128,0.25)'
                    }}
                    style={{
                      border: '1px solid #1D5C39',
                      borderRadius: '18px',
                      padding: isMobile ? '12px' : '15px',
                      background: '#0F2E1D',
                      display: 'flex',
                      flexDirection: isMobile ? 'column' : 'row',
                      gap: '15px',
                      alignItems: 'center',
                      textAlign: isMobile ? 'center' : 'left'
                    }}
                  >
                    <img
                      src={nervanaLogo}
                      alt="Nervana"
                      style={{
                        width: isMobile ? '55px' : '70px',
                        height: isMobile ? '55px' : '70px',
                        objectFit: 'contain'
                      }}
                    />

                    <div>
                      <h5
                        style={{
                          color: '#7CFFB2',
                          marginBottom: '6px',
                          fontSize: isMobile ? '15px' : '16px'
                        }}
                      >
                        Nervana
                      </h5>

                      <p
                        style={{
                          color: '#D8FBE5',
                          fontSize: isMobile ? '11px' : '14px',
                          margin: 0,
                          lineHeight: '1.6'
                        }}
                      >
                        AI-led personal branding company working with founders and operators
                        across the UK, US and global markets.
                      </p>
                    </div>
                  </motion.div>

                  {/* Box 2 - Sociazy */}
                  <motion.div
                    whileHover={{
                      scale: 1.02,
                      boxShadow: '0 0 20px rgba(96,165,250,0.25)'
                    }}
                    style={{
                      border: '1px solid #285A9B',
                      borderRadius: '18px',
                      padding: isMobile ? '12px' : '15px',
                      background: '#10253F',
                      display: 'flex',
                      flexDirection: isMobile ? 'column' : 'row',
                      gap: '15px',
                      alignItems: 'center',
                      textAlign: isMobile ? 'center' : 'left'
                    }}
                  >
                    <img
                      src={sociazyLogo}
                      alt="Sociazy"
                      style={{
                        width: isMobile ? '55px' : '70px',
                        height: isMobile ? '55px' : '70px',
                        objectFit: 'contain'
                      }}
                    />

                    <div>
                      <h5
                        style={{
                          color: '#7DB9FF',
                          marginBottom: '6px',
                          fontSize: isMobile ? '15px' : '16px'
                        }}
                      >
                        Sociazy
                      </h5>

                      <p
                        style={{
                          color: '#DCEBFF',
                          fontSize: isMobile ? '11px' : '14px',
                          margin: 0,
                          lineHeight: '1.6'
                        }}
                      >
                        Technology & AI transformation company serving enterprise clients
                        across the UAE, India and North America.
                      </p>
                    </div>
                  </motion.div>

                  {/* Box 3 - S51 Agency */}
                  <motion.div
                    whileHover={{
                      scale: 1.02,
                      boxShadow: '0 0 20px rgba(244,114,182,0.25)'
                    }}
                    style={{
                      border: '1px solid #7B2F63',
                      borderRadius: '18px',
                      padding: isMobile ? '12px' : '15px',
                      background: '#3A1830',
                      display: 'flex',
                      flexDirection: isMobile ? 'column' : 'row',
                      gap: '15px',
                      alignItems: 'center',
                      textAlign: isMobile ? 'center' : 'left'
                    }}
                  >
                    <img
                      src={s51Logo}
                      alt="S51 Agency"
                      style={{
                        width: isMobile ? '55px' : '70px',
                        height: isMobile ? '55px' : '70px',
                        objectFit: 'contain'
                      }}
                    />

                    <div>
                      <h5
                        style={{
                          color: '#FF9DCE',
                          marginBottom: '6px',
                          fontSize: isMobile ? '15px' : '16px'
                        }}
                      >
                        S51 Agency
                      </h5>

                      <p
                        style={{
                          color: '#FFE1F0',
                          fontSize: isMobile ? '11px' : '14px',
                          margin: 0,
                          lineHeight: '1.6'
                        }}
                      >
                        Strategic storytelling agency helping B2B and SaaS brands across the
                        US, UK, Europe and APAC communicate complex value with clarity.
                      </p>
                    </div>
                  </motion.div>

                  {/* Box 4 - BluBox Media */}
                  <motion.div
                    whileHover={{
                      scale: 1.02,
                      boxShadow: '0 0 20px rgba(251,191,36,0.25)'
                    }}
                    style={{
                      border: '1px solid #8A6A15',
                      borderRadius: '18px',
                      padding: isMobile ? '12px' : '15px',
                      background: '#3D2F0D',
                      display: 'flex',
                      flexDirection: isMobile ? 'column' : 'row',
                      gap: '15px',
                      alignItems: 'center',
                      textAlign: isMobile ? 'center' : 'left'
                    }}
                  >
                    <img
                      src={bluBoxLogo}
                      alt="BluBox Media"
                      style={{
                        width: isMobile ? '55px' : '70px',
                        height: isMobile ? '55px' : '70px',
                        objectFit: 'contain'
                      }}
                    />

                    <div>
                      <h5
                        style={{
                          color: '#FFD86B',
                          marginBottom: '6px',
                          fontSize: isMobile ? '15px' : '16px'
                        }}
                      >
                        BluBox Media
                      </h5>

                      <p
                        style={{
                          color: '#FFF1C4',
                          fontSize: isMobile ? '11px' : '14px',
                          margin: 0,
                          lineHeight: '1.6'
                        }}
                      >
                        Performance media buying agency for high-growth eCommerce brands.
                      </p>
                    </div>
                  </motion.div>

                </div>

              </div>
            )}



            {currentPage === 6 && (

              <div
                style={{
                  height: isMobile ? '40vh' : '550px',
                  maxHeight: isMobile ? '40vh' : '550px',
                  position: 'relative',
                  overflowY: isMobile ? 'auto' : 'visible',
                  overflowX: 'hidden',
                  borderRadius: isMobile ? '15px' : '20px',
                  background: 'transparent',
                  paddingBottom: isMobile ? '80px' : '0',
                  WebkitOverflowScrolling: 'touch'
                }}
              >

                {/* Background Image */}
                <img
                  src={portfolio2}
                  alt="Portfolio Slide"
                  style={{
                    position: 'absolute',
                    inset: 0,
                    width: '100%',
                    height: '100%',
                    objectFit: isMobile ? 'contain' : 'cover',
                    background: '#000',
                    zIndex: 0,
                    borderRadius: isMobile ? '15px' : '20px'
                  }}
                />

                {/* Top Right Circular Button */}
                <motion.button
                  onClick={() =>
                    window.open(
                      'https://peregrinee.com',
                      '_blank',
                      'noopener,noreferrer'
                    )
                  }
                  whileHover={{
                    scale: 1.1,
                    rotate: 45,
                    boxShadow: '0 0 20px rgba(255,255,255,0.3)'
                  }}
                  whileTap={{
                    scale: 0.95
                  }}
                  style={{
                    position: 'absolute',
                    top: isMobile ? '10px' : '15px',
                    right: isMobile ? '10px' : '15px',
                    width: isMobile ? '42px' : '55px',
                    height: isMobile ? '42px' : '55px',
                    borderRadius: '50%',
                    border: 'none',
                    background:
                      'linear-gradient(135deg,#ff4d8d,#c44dff)',
                    color: '#fff',
                    fontSize: isMobile ? '18px' : '24px',
                    cursor: 'pointer',
                    fontWeight: 'bold',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 10
                  }}
                >
                  <FaArrowUp size={isMobile ? 16 : 20} />
                </motion.button>

                {/* Right Sticky Buttons */}
                <div
                  style={{
                    position: 'absolute',
                    right: isMobile ? '50%' : '-85px',
                    bottom: isMobile ? '10px' : 'auto',
                    top: isMobile ? 'auto' : '50%',
                    transform: isMobile
                      ? 'translateX(50%)'
                      : 'translateY(-50%)',
                    display: 'flex',
                    flexDirection: isMobile ? 'row' : 'column',
                    gap: isMobile ? '8px' : '12px',
                    zIndex: 20
                  }}
                >

                  {/* Home */}
                  <motion.button
                    onClick={() =>
                      window.open(
                        'https://peregrinee.com',
                        '_blank',
                        'noopener,noreferrer'
                      )
                    }
                    whileHover={{
                      scale: 1.08,
                      x: isMobile ? 0 : -5
                    }}
                    style={{
                      width: isMobile ? '55px' : '70px',
                      height: isMobile ? '55px' : '70px',
                      borderRadius: isMobile ? '14px' : '18px',
                      border: 'none',
                      background: '#222',
                      color: '#fff',
                      cursor: 'pointer',
                      fontSize: isMobile ? '9px' : '12px',
                      fontWeight: '700',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: isMobile ? '3px' : '6px',
                    }}
                  >
                    <FaHome size={isMobile ? 16 : 22} />
                    Home
                  </motion.button>

                  {/* Work */}
                  <motion.button
                    onClick={() =>
                      window.open(
                        'https://www.peregrinee.com/case-studies',
                        '_blank',
                        'noopener,noreferrer'
                      )
                    }
                    whileHover={{
                      scale: 1.08,
                      x: isMobile ? 0 : -5
                    }}
                    style={{
                      width: isMobile ? '55px' : '70px',
                      height: isMobile ? '55px' : '70px',
                      borderRadius: isMobile ? '14px' : '18px',
                      border: 'none',
                      background: '#222',
                      color: '#fff',
                      cursor: 'pointer',
                      fontSize: isMobile ? '9px' : '12px',
                      fontWeight: '700',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: isMobile ? '3px' : '6px',
                    }}
                  >
                    <FaFolderOpen size={isMobile ? 16 : 22} />
                    Work
                  </motion.button>

                  {/* Contact */}
                  <motion.button
                    onClick={() =>
                      window.open(
                        'https://www.peregrinee.com/contact-us',
                        '_blank',
                        'noopener,noreferrer'
                      )
                    }
                    whileHover={{
                      scale: 1.08,
                      x: isMobile ? 0 : -5
                    }}
                    style={{
                      width: isMobile ? '55px' : '70px',
                      height: isMobile ? '55px' : '70px',
                      borderRadius: isMobile ? '14px' : '18px',
                      border: 'none',
                      background: '#222',
                      color: '#fff',
                      cursor: 'pointer',
                      fontSize: isMobile ? '9px' : '12px',
                      fontWeight: '700',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: isMobile ? '3px' : '6px',
                    }}
                  >
                    <FaEnvelope size={isMobile ? 16 : 22} />
                    Contact
                  </motion.button>

                </div>

              </div>

            )}

            {currentPage === 7 && (

              <div
                style={{
                  height: isMobile ? '40vh' : '550px',
                  maxHeight: isMobile ? '40vh' : '570px',
                  position: 'relative',
                  overflowY: isMobile ? 'auto' : 'visible',
                  overflowX: 'hidden',
                  borderRadius: isMobile ? '15px' : '20px',
                  background: 'transparent',
                  paddingBottom: isMobile ? '80px' : '0',
                  WebkitOverflowScrolling: 'touch'
                }}
              >

                {/* Background Image */}
                <img
                  src={portfolio3}
                  alt="Portfolio Slide"
                  style={{
                    position: 'absolute',
                    inset: 0,
                    width: '100%',
                    height: '100%',
                    objectFit: isMobile ? 'contain' : 'cover',
                    background: '#000',
                    zIndex: 0,
                    borderRadius: isMobile ? '15px' : '20px'
                  }}
                />

                {/* Top Right Circular Button */}
                <motion.button
                  onClick={() =>
                    window.open(
                      'https://peregrinee.com',
                      '_blank',
                      'noopener,noreferrer'
                    )
                  }
                  whileHover={{
                    scale: 1.1,
                    rotate: 45,
                    boxShadow: '0 0 20px rgba(255,255,255,0.3)'
                  }}
                  whileTap={{
                    scale: 0.95
                  }}
                  style={{
                    position: 'absolute',
                    top: isMobile ? '10px' : '15px',
                    right: isMobile ? '10px' : '15px',
                    width: isMobile ? '42px' : '55px',
                    height: isMobile ? '42px' : '55px',
                    borderRadius: '50%',
                    border: 'none',
                    background:
                      'linear-gradient(135deg,#ff4d8d,#c44dff)',
                    color: '#fff',
                    fontSize: isMobile ? '18px' : '24px',
                    cursor: 'pointer',
                    fontWeight: 'bold',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 10
                  }}
                >
                  <FaArrowUp size={isMobile ? 16 : 20} />
                </motion.button>

                {/* Right Sticky Buttons */}
                <div
                  style={{
                    position: 'absolute',
                    right: isMobile ? '50%' : '-85px',
                    bottom: isMobile ? '10px' : 'auto',
                    top: isMobile ? 'auto' : '50%',
                    transform: isMobile
                      ? 'translateX(50%)'
                      : 'translateY(-50%)',
                    display: 'flex',
                    flexDirection: isMobile ? 'row' : 'column',
                    gap: isMobile ? '8px' : '12px',
                    zIndex: 20
                  }}
                >

                  {/* Home */}
                  <motion.button
                    onClick={() =>
                      window.open(
                        'https://peregrinee.com',
                        '_blank',
                        'noopener,noreferrer'
                      )
                    }
                    whileHover={{
                      scale: 1.08,
                      x: isMobile ? 0 : -5
                    }}
                    style={{
                      width: isMobile ? '55px' : '70px',
                      height: isMobile ? '55px' : '70px',
                      borderRadius: isMobile ? '14px' : '18px',
                      border: 'none',
                      background: '#222',
                      color: '#fff',
                      cursor: 'pointer',
                      fontSize: isMobile ? '9px' : '12px',
                      fontWeight: '700',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: isMobile ? '3px' : '6px',
                    }}
                  >
                    <FaHome size={isMobile ? 16 : 22} />
                    Home
                  </motion.button>

                  {/* Work */}
                  <motion.button
                    onClick={() =>
                      window.open(
                        'https://www.peregrinee.com/case-studies',
                        '_blank',
                        'noopener,noreferrer'
                      )
                    }
                    whileHover={{
                      scale: 1.08,
                      x: isMobile ? 0 : -5
                    }}
                    style={{
                      width: isMobile ? '55px' : '70px',
                      height: isMobile ? '55px' : '70px',
                      borderRadius: isMobile ? '14px' : '18px',
                      border: 'none',
                      background: '#222',
                      color: '#fff',
                      cursor: 'pointer',
                      fontSize: isMobile ? '9px' : '12px',
                      fontWeight: '700',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: isMobile ? '3px' : '6px',
                    }}
                  >
                    <FaFolderOpen size={isMobile ? 16 : 22} />
                    Work
                  </motion.button>

                  {/* Contact */}
                  <motion.button
                    onClick={() =>
                      window.open(
                        'https://www.peregrinee.com/contact-us',
                        '_blank',
                        'noopener,noreferrer'
                      )
                    }
                    whileHover={{
                      scale: 1.08,
                      x: isMobile ? 0 : -5
                    }}
                    style={{
                      width: isMobile ? '55px' : '70px',
                      height: isMobile ? '55px' : '70px',
                      borderRadius: isMobile ? '14px' : '18px',
                      border: 'none',
                      background: '#222',
                      color: '#fff',
                      cursor: 'pointer',
                      fontSize: isMobile ? '9px' : '12px',
                      fontWeight: '700',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: isMobile ? '3px' : '6px',
                    }}
                  >
                    <FaEnvelope size={isMobile ? 16 : 22} />
                    Contact
                  </motion.button>

                </div>

              </div>

            )}


            {currentPage === 8 && (

              <div
                style={{
                  height: isMobile ? '40vh' : '570px',
                  maxHeight: isMobile ? '40vh' : '570px',
                  position: 'relative',
                  overflowY: isMobile ? 'auto' : 'visible',
                  overflowX: 'hidden',
                  borderRadius: isMobile ? '15px' : '20px',
                  background: 'transparent',
                  paddingBottom: isMobile ? '80px' : '0',
                  WebkitOverflowScrolling: 'touch'
                }}
              >

                {/* Background Image */}
                <img
                  src={portfolio5}
                  alt="Portfolio Slide"
                  style={{
                    position: 'absolute',
                    inset: 0,
                    width: '100%',
                    height: '100%',
                    objectFit: isMobile ? 'contain' : 'cover',
                    background: '#000',
                    zIndex: 0,
                    borderRadius: isMobile ? '15px' : '20px'
                  }}
                />

                {/* Top Right Circular Button */}
                <motion.button
                  onClick={() =>
                    window.open(
                      'https://peregrinee.com',
                      '_blank',
                      'noopener,noreferrer'
                    )
                  }
                  whileHover={{
                    scale: 1.1,
                    rotate: 45,
                    boxShadow: '0 0 20px rgba(255,255,255,0.3)'
                  }}
                  whileTap={{
                    scale: 0.95
                  }}
                  style={{
                    position: 'absolute',
                    top: isMobile ? '10px' : '15px',
                    right: isMobile ? '10px' : '15px',
                    width: isMobile ? '42px' : '55px',
                    height: isMobile ? '42px' : '55px',
                    borderRadius: '50%',
                    border: 'none',
                    background:
                      'linear-gradient(135deg,#ff4d8d,#c44dff)',
                    color: '#fff',
                    fontSize: isMobile ? '18px' : '24px',
                    cursor: 'pointer',
                    fontWeight: 'bold',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 10
                  }}
                >
                  <FaArrowUp size={isMobile ? 16 : 20} />
                </motion.button>

                {/* Right Sticky Buttons */}
                <div
                  style={{
                    position: 'absolute',
                    right: isMobile ? '50%' : '-85px',
                    bottom: isMobile ? '10px' : 'auto',
                    top: isMobile ? 'auto' : '50%',
                    transform: isMobile
                      ? 'translateX(50%)'
                      : 'translateY(-50%)',
                    display: 'flex',
                    flexDirection: isMobile ? 'row' : 'column',
                    gap: isMobile ? '8px' : '12px',
                    zIndex: 20
                  }}
                >

                  {/* Home */}
                  <motion.button
                    onClick={() =>
                      window.open(
                        'https://peregrinee.com',
                        '_blank',
                        'noopener,noreferrer'
                      )
                    }
                    whileHover={{
                      scale: 1.08,
                      x: isMobile ? 0 : -5
                    }}
                    style={{
                      width: isMobile ? '55px' : '70px',
                      height: isMobile ? '55px' : '70px',
                      borderRadius: isMobile ? '14px' : '18px',
                      border: 'none',
                      background: '#222',
                      color: '#fff',
                      cursor: 'pointer',
                      fontSize: isMobile ? '9px' : '12px',
                      fontWeight: '700',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: isMobile ? '3px' : '6px',
                    }}
                  >
                    <FaHome size={isMobile ? 16 : 22} />
                    Home
                  </motion.button>

                  {/* Work */}
                  <motion.button
                    onClick={() =>
                      window.open(
                        'https://www.peregrinee.com/case-studies',
                        '_blank',
                        'noopener,noreferrer'
                      )
                    }
                    whileHover={{
                      scale: 1.08,
                      x: isMobile ? 0 : -5
                    }}
                    style={{
                      width: isMobile ? '55px' : '70px',
                      height: isMobile ? '55px' : '70px',
                      borderRadius: isMobile ? '14px' : '18px',
                      border: 'none',
                      background: '#222',
                      color: '#fff',
                      cursor: 'pointer',
                      fontSize: isMobile ? '9px' : '12px',
                      fontWeight: '700',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: isMobile ? '3px' : '6px',
                    }}
                  >
                    <FaFolderOpen size={isMobile ? 16 : 22} />
                    Work
                  </motion.button>

                  {/* Contact */}
                  <motion.button
                    onClick={() =>
                      window.open(
                        'https://www.peregrinee.com/contact-us',
                        '_blank',
                        'noopener,noreferrer'
                      )
                    }
                    whileHover={{
                      scale: 1.08,
                      x: isMobile ? 0 : -5
                    }}
                    style={{
                      width: isMobile ? '55px' : '70px',
                      height: isMobile ? '55px' : '70px',
                      borderRadius: isMobile ? '14px' : '18px',
                      border: 'none',
                      background: '#222',
                      color: '#fff',
                      cursor: 'pointer',
                      fontSize: isMobile ? '9px' : '12px',
                      fontWeight: '700',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: isMobile ? '3px' : '6px',
                    }}
                  >
                    <FaEnvelope size={isMobile ? 16 : 22} />
                    Contact
                  </motion.button>

                </div>

              </div>

            )}

            {currentPage === 9 && (

              <div
                style={{
                  height: isMobile ? '300px' : '550px',
                  position: 'relative',
                  overflow: 'visible',
                  borderRadius: isMobile ? '15px' : '20px',

                  background: 'rgba(255, 255, 255, 0.08)',
                  backdropFilter: 'blur(12px)',
                  WebkitBackdropFilter: 'blur(12px)',

                  border: '1px solid rgba(255, 255, 255, 0.25)',
                  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.15)',

                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'column',
                }}
              >

                {/* Center Content */}
                <div
                  style={{
                    textAlign: 'center',
                    zIndex: 2,
                  }}
                >
                  <h2
                    style={{
                      color: '#fff',
                      fontSize: isMobile ? '32px' : '52px',
                      fontWeight: '700',
                      marginBottom: '20px',
                    }}
                  >
                    Our Case Studies
                  </h2>

                  <motion.button
                    onClick={() => setCurrentPage(currentPage + 1)}
                    whileHover={{
                      scale: 1.05,
                      y: -2,
                    }}
                    whileTap={{
                      scale: 0.95,
                    }}
                    style={{
                      padding: isMobile ? '12px 28px' : '14px 36px',
                      borderRadius: '50px',
                      border: 'none',
                      background: 'linear-gradient(135deg,#ff4d8d,#c44dff)',
                      color: '#fff',
                      fontSize: isMobile ? '14px' : '16px',
                      fontWeight: '700',
                      cursor: 'pointer',
                      boxShadow: '0 8px 25px rgba(196,77,255,0.35)',
                    }}
                  >
                    View
                  </motion.button>
                </div>

                {/* Top Right Circular Button */}
                <motion.button
                  onClick={() =>
                    window.open(
                      'https://peregrinee.com',
                      '_blank',
                      'noopener,noreferrer'
                    )
                  }
                  whileHover={{
                    scale: 1.1,
                    rotate: 45,
                    boxShadow: '0 0 20px rgba(255,255,255,0.3)'
                  }}
                  whileTap={{
                    scale: 0.95
                  }}
                  style={{
                    position: 'absolute',
                    top: isMobile ? '10px' : '15px',
                    right: isMobile ? '10px' : '15px',
                    width: isMobile ? '42px' : '55px',
                    height: isMobile ? '42px' : '55px',
                    borderRadius: '50%',
                    border: 'none',
                    background: 'linear-gradient(135deg,#ff4d8d,#c44dff)',
                    color: '#fff',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 10
                  }}
                >
                  <FaArrowUp size={isMobile ? 16 : 20} />
                </motion.button>

                {/* Right Sticky Buttons */}
                <div
                  style={{
                    position: 'absolute',
                    right: isMobile ? '50%' : '-85px',
                    bottom: isMobile ? '10px' : 'auto',
                    top: isMobile ? 'auto' : '50%',
                    transform: isMobile
                      ? 'translateX(50%)'
                      : 'translateY(-50%)',
                    display: 'flex',
                    flexDirection: isMobile ? 'row' : 'column',
                    gap: isMobile ? '8px' : '12px',
                    zIndex: 20
                  }}
                >

                  {/* Home */}
                  <motion.button
                    onClick={() =>
                      window.open(
                        'https://peregrinee.com',
                        '_blank',
                        'noopener,noreferrer'
                      )
                    }
                    whileHover={{
                      scale: 1.08,
                      x: isMobile ? 0 : -5
                    }}
                    style={{
                      width: isMobile ? '55px' : '70px',
                      height: isMobile ? '55px' : '70px',
                      borderRadius: isMobile ? '14px' : '18px',
                      border: 'none',
                      background: '#222',
                      color: '#fff',
                      cursor: 'pointer',
                      fontSize: isMobile ? '9px' : '12px',
                      fontWeight: '700',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: isMobile ? '3px' : '6px',
                    }}
                  >
                    <FaHome size={isMobile ? 16 : 22} />
                    Home
                  </motion.button>

                  {/* Work */}
                  <motion.button
                    onClick={() =>
                      window.open(
                        'https://www.peregrinee.com/case-studies',
                        '_blank',
                        'noopener,noreferrer'
                      )
                    }
                    whileHover={{
                      scale: 1.08,
                      x: isMobile ? 0 : -5
                    }}
                    style={{
                      width: isMobile ? '55px' : '70px',
                      height: isMobile ? '55px' : '70px',
                      borderRadius: isMobile ? '14px' : '18px',
                      border: 'none',
                      background: '#222',
                      color: '#fff',
                      cursor: 'pointer',
                      fontSize: isMobile ? '9px' : '12px',
                      fontWeight: '700',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: isMobile ? '3px' : '6px',
                    }}
                  >
                    <FaFolderOpen size={isMobile ? 16 : 22} />
                    Work
                  </motion.button>

                  {/* Contact */}
                  <motion.button
                    onClick={() =>
                      window.open(
                        'https://www.peregrinee.com/contact-us',
                        '_blank',
                        'noopener,noreferrer'
                      )
                    }
                    whileHover={{
                      scale: 1.08,
                      x: isMobile ? 0 : -5
                    }}
                    style={{
                      width: isMobile ? '55px' : '70px',
                      height: isMobile ? '55px' : '70px',
                      borderRadius: isMobile ? '14px' : '18px',
                      border: 'none',
                      background: '#222',
                      color: '#fff',
                      cursor: 'pointer',
                      fontSize: isMobile ? '9px' : '12px',
                      fontWeight: '700',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: isMobile ? '3px' : '6px',
                    }}
                  >
                    <FaEnvelope size={isMobile ? 16 : 22} />
                    Contact
                  </motion.button>

                </div>

              </div>

            )}

            {currentPage === 10 && (

              <div
                style={{
                  height: isMobile ? '40vh' : '550px',
                  maxHeight: isMobile ? '40vh' : '580px',
                  position: 'relative',
                  overflowY: isMobile ? 'auto' : 'visible',
                  overflowX: 'hidden',
                  borderRadius: isMobile ? '15px' : '20px',
                  background: '#000',
                  paddingBottom: isMobile ? '80px' : '0',
                  WebkitOverflowScrolling: 'touch'
                }}
              >

                {/* Background Image */}
                <img
                  src={portfolio10}
                  alt="Portfolio Slide"
                  style={{
                    position: 'absolute',
                    inset: 0,
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                    objectPosition: 'center center',
                    zIndex: 0,
                    borderRadius: isMobile ? '15px' : '20px'
                  }}
                />

                {/* Top Right Circular Button */}
                <motion.button
                  onClick={() =>
                    window.open(
                      'https://peregrinee.com',
                      '_blank',
                      'noopener,noreferrer'
                    )
                  }
                  whileHover={{
                    scale: 1.1,
                    rotate: 45,
                    boxShadow: '0 0 20px rgba(255,255,255,0.3)'
                  }}
                  whileTap={{
                    scale: 0.95
                  }}
                  style={{
                    position: 'absolute',
                    top: isMobile ? '10px' : '15px',
                    right: isMobile ? '10px' : '15px',
                    width: isMobile ? '42px' : '55px',
                    height: isMobile ? '42px' : '55px',
                    borderRadius: '50%',
                    border: 'none',
                    background:
                      'linear-gradient(135deg,#ff4d8d,#c44dff)',
                    color: '#fff',
                    fontSize: isMobile ? '18px' : '24px',
                    cursor: 'pointer',
                    fontWeight: 'bold',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 10
                  }}
                >
                  <FaArrowUp size={isMobile ? 16 : 20} />
                </motion.button>

                {/* Right Sticky Buttons */}
                <div
                  style={{
                    position: 'absolute',
                    right: isMobile ? '50%' : '-85px',
                    bottom: isMobile ? '10px' : 'auto',
                    top: isMobile ? 'auto' : '50%',
                    transform: isMobile
                      ? 'translateX(50%)'
                      : 'translateY(-50%)',
                    display: 'flex',
                    flexDirection: isMobile ? 'row' : 'column',
                    gap: isMobile ? '8px' : '12px',
                    zIndex: 20
                  }}
                >

                  <motion.button
                    onClick={() =>
                      window.open(
                        'https://peregrinee.com',
                        '_blank',
                        'noopener,noreferrer'
                      )
                    }
                    whileHover={{
                      scale: 1.08,
                      x: isMobile ? 0 : -5
                    }}
                    style={{
                      width: isMobile ? '55px' : '70px',
                      height: isMobile ? '55px' : '70px',
                      borderRadius: isMobile ? '14px' : '18px',
                      border: 'none',
                      background: '#222',
                      color: '#fff',
                      cursor: 'pointer',
                      fontSize: isMobile ? '9px' : '12px',
                      fontWeight: '700',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: isMobile ? '3px' : '6px',
                    }}
                  >
                    <FaHome size={isMobile ? 16 : 22} />
                    Home
                  </motion.button>

                  <motion.button
                    onClick={() =>
                      window.open(
                        'https://www.peregrinee.com/case-studies',
                        '_blank',
                        'noopener,noreferrer'
                      )
                    }
                    whileHover={{
                      scale: 1.08,
                      x: isMobile ? 0 : -5
                    }}
                    style={{
                      width: isMobile ? '55px' : '70px',
                      height: isMobile ? '55px' : '70px',
                      borderRadius: isMobile ? '14px' : '18px',
                      border: 'none',
                      background: '#222',
                      color: '#fff',
                      cursor: 'pointer',
                      fontSize: isMobile ? '9px' : '12px',
                      fontWeight: '700',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: isMobile ? '3px' : '6px',
                    }}
                  >
                    <FaFolderOpen size={isMobile ? 16 : 22} />
                    Work
                  </motion.button>

                  <motion.button
                    onClick={() =>
                      window.open(
                        'https://www.peregrinee.com/contact-us',
                        '_blank',
                        'noopener,noreferrer'
                      )
                    }
                    whileHover={{
                      scale: 1.08,
                      x: isMobile ? 0 : -5
                    }}
                    style={{
                      width: isMobile ? '55px' : '70px',
                      height: isMobile ? '55px' : '70px',
                      borderRadius: isMobile ? '14px' : '18px',
                      border: 'none',
                      background: '#222',
                      color: '#fff',
                      cursor: 'pointer',
                      fontSize: isMobile ? '9px' : '12px',
                      fontWeight: '700',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: isMobile ? '3px' : '6px',
                    }}
                  >
                    <FaEnvelope size={isMobile ? 16 : 22} />
                    Contact
                  </motion.button>

                </div>

              </div>

            )}

            {currentPage === 11 && (

              <div
                style={{
                  height: isMobile ? '40vh' : '550px',
                  maxHeight: isMobile ? '40vh' : '580px',
                  position: 'relative',
                  overflowY: isMobile ? 'auto' : 'visible',
                  overflowX: 'hidden',
                  borderRadius: isMobile ? '15px' : '20px',
                  background: '#000',
                  paddingBottom: isMobile ? '80px' : '0',
                  WebkitOverflowScrolling: 'touch'
                }}
              >

                {/* Background Image */}
                <img
                  src={portfolio11}
                  alt="Portfolio Slide"
                  style={{
                    position: 'absolute',
                    inset: 0,
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                    objectPosition: 'center center',
                    zIndex: 0,
                    borderRadius: isMobile ? '15px' : '20px'
                  }}
                />

                {/* Top Right Circular Button */}
                <motion.button
                  onClick={() =>
                    window.open(
                      'https://peregrinee.com',
                      '_blank',
                      'noopener,noreferrer'
                    )
                  }
                  whileHover={{
                    scale: 1.1,
                    rotate: 45,
                    boxShadow: '0 0 20px rgba(255,255,255,0.3)'
                  }}
                  whileTap={{
                    scale: 0.95
                  }}
                  style={{
                    position: 'absolute',
                    top: isMobile ? '10px' : '15px',
                    right: isMobile ? '10px' : '15px',
                    width: isMobile ? '42px' : '55px',
                    height: isMobile ? '42px' : '55px',
                    borderRadius: '50%',
                    border: 'none',
                    background:
                      'linear-gradient(135deg,#ff4d8d,#c44dff)',
                    color: '#fff',
                    fontSize: isMobile ? '18px' : '24px',
                    cursor: 'pointer',
                    fontWeight: 'bold',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 10
                  }}
                >
                  <FaArrowUp size={isMobile ? 16 : 20} />
                </motion.button>

                {/* Right Sticky Buttons */}
                <div
                  style={{
                    position: 'absolute',
                    right: isMobile ? '50%' : '-85px',
                    bottom: isMobile ? '10px' : 'auto',
                    top: isMobile ? 'auto' : '50%',
                    transform: isMobile
                      ? 'translateX(50%)'
                      : 'translateY(-50%)',
                    display: 'flex',
                    flexDirection: isMobile ? 'row' : 'column',
                    gap: isMobile ? '8px' : '12px',
                    zIndex: 20
                  }}
                >

                  <motion.button
                    onClick={() =>
                      window.open(
                        'https://peregrinee.com',
                        '_blank',
                        'noopener,noreferrer'
                      )
                    }
                    whileHover={{
                      scale: 1.08,
                      x: isMobile ? 0 : -5
                    }}
                    style={{
                      width: isMobile ? '55px' : '70px',
                      height: isMobile ? '55px' : '70px',
                      borderRadius: isMobile ? '14px' : '18px',
                      border: 'none',
                      background: '#222',
                      color: '#fff',
                      cursor: 'pointer',
                      fontSize: isMobile ? '9px' : '12px',
                      fontWeight: '700',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: isMobile ? '3px' : '6px',
                    }}
                  >
                    <FaHome size={isMobile ? 16 : 22} />
                    Home
                  </motion.button>

                  <motion.button
                    onClick={() =>
                      window.open(
                        'https://www.peregrinee.com/case-studies',
                        '_blank',
                        'noopener,noreferrer'
                      )
                    }
                    whileHover={{
                      scale: 1.08,
                      x: isMobile ? 0 : -5
                    }}
                    style={{
                      width: isMobile ? '55px' : '70px',
                      height: isMobile ? '55px' : '70px',
                      borderRadius: isMobile ? '14px' : '18px',
                      border: 'none',
                      background: '#222',
                      color: '#fff',
                      cursor: 'pointer',
                      fontSize: isMobile ? '9px' : '12px',
                      fontWeight: '700',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: isMobile ? '3px' : '6px',
                    }}
                  >
                    <FaFolderOpen size={isMobile ? 16 : 22} />
                    Work
                  </motion.button>

                  <motion.button
                    onClick={() =>
                      window.open(
                        'https://www.peregrinee.com/contact-us',
                        '_blank',
                        'noopener,noreferrer'
                      )
                    }
                    whileHover={{
                      scale: 1.08,
                      x: isMobile ? 0 : -5
                    }}
                    style={{
                      width: isMobile ? '55px' : '70px',
                      height: isMobile ? '55px' : '70px',
                      borderRadius: isMobile ? '14px' : '18px',
                      border: 'none',
                      background: '#222',
                      color: '#fff',
                      cursor: 'pointer',
                      fontSize: isMobile ? '9px' : '12px',
                      fontWeight: '700',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: isMobile ? '3px' : '6px',
                    }}
                  >
                    <FaEnvelope size={isMobile ? 16 : 22} />
                    Contact
                  </motion.button>

                </div>

              </div>

            )}

            {currentPage === 12 && (

              <div
                style={{
                  height: isMobile ? '40vh' : '550px',
                  maxHeight: isMobile ? '40vh' : '550px',
                  position: 'relative',
                  overflowY: isMobile ? 'auto' : 'visible',
                  overflowX: 'hidden',
                  borderRadius: isMobile ? '15px' : '20px',
                  background: '#000',
                  paddingBottom: isMobile ? '80px' : '0',
                  WebkitOverflowScrolling: 'touch'
                }}
              >

                {/* Background Image */}
                <img
                  src={portfolio12}
                  alt="Portfolio Slide"
                  style={{
                    position: 'absolute',
                    inset: 0,
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                    objectPosition: 'center center',
                    zIndex: 0,
                    borderRadius: isMobile ? '15px' : '20px'
                  }}
                />

                {/* Top Right Circular Button */}
                <motion.button
                  onClick={() =>
                    window.open(
                      'https://peregrinee.com',
                      '_blank',
                      'noopener,noreferrer'
                    )
                  }
                  whileHover={{
                    scale: 1.1,
                    rotate: 45,
                    boxShadow: '0 0 20px rgba(255,255,255,0.3)'
                  }}
                  whileTap={{
                    scale: 0.95
                  }}
                  style={{
                    position: 'absolute',
                    top: isMobile ? '10px' : '15px',
                    right: isMobile ? '10px' : '15px',
                    width: isMobile ? '42px' : '55px',
                    height: isMobile ? '42px' : '55px',
                    borderRadius: '50%',
                    border: 'none',
                    background:
                      'linear-gradient(135deg,#ff4d8d,#c44dff)',
                    color: '#fff',
                    fontSize: isMobile ? '18px' : '24px',
                    cursor: 'pointer',
                    fontWeight: 'bold',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 10
                  }}
                >
                  <FaArrowUp size={isMobile ? 16 : 20} />
                </motion.button>

                {/* Right Sticky Buttons */}
                <div
                  style={{
                    position: 'absolute',
                    right: isMobile ? '50%' : '-85px',
                    bottom: isMobile ? '10px' : 'auto',
                    top: isMobile ? 'auto' : '50%',
                    transform: isMobile
                      ? 'translateX(50%)'
                      : 'translateY(-50%)',
                    display: 'flex',
                    flexDirection: isMobile ? 'row' : 'column',
                    gap: isMobile ? '8px' : '12px',
                    zIndex: 20
                  }}
                >

                  <motion.button
                    onClick={() =>
                      window.open(
                        'https://peregrinee.com',
                        '_blank',
                        'noopener,noreferrer'
                      )
                    }
                    whileHover={{
                      scale: 1.08,
                      x: isMobile ? 0 : -5
                    }}
                    style={{
                      width: isMobile ? '55px' : '70px',
                      height: isMobile ? '55px' : '70px',
                      borderRadius: isMobile ? '14px' : '18px',
                      border: 'none',
                      background: '#222',
                      color: '#fff',
                      cursor: 'pointer',
                      fontSize: isMobile ? '9px' : '12px',
                      fontWeight: '700',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: isMobile ? '3px' : '6px',
                    }}
                  >
                    <FaHome size={isMobile ? 16 : 22} />
                    Home
                  </motion.button>

                  <motion.button
                    onClick={() =>
                      window.open(
                        'https://www.peregrinee.com/case-studies',
                        '_blank',
                        'noopener,noreferrer'
                      )
                    }
                    whileHover={{
                      scale: 1.08,
                      x: isMobile ? 0 : -5
                    }}
                    style={{
                      width: isMobile ? '55px' : '70px',
                      height: isMobile ? '55px' : '70px',
                      borderRadius: isMobile ? '14px' : '18px',
                      border: 'none',
                      background: '#222',
                      color: '#fff',
                      cursor: 'pointer',
                      fontSize: isMobile ? '9px' : '12px',
                      fontWeight: '700',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: isMobile ? '3px' : '6px',
                    }}
                  >
                    <FaFolderOpen size={isMobile ? 16 : 22} />
                    Work
                  </motion.button>

                  <motion.button
                    onClick={() =>
                      window.open(
                        'https://www.peregrinee.com/contact-us',
                        '_blank',
                        'noopener,noreferrer'
                      )
                    }
                    whileHover={{
                      scale: 1.08,
                      x: isMobile ? 0 : -5
                    }}
                    style={{
                      width: isMobile ? '55px' : '70px',
                      height: isMobile ? '55px' : '70px',
                      borderRadius: isMobile ? '14px' : '18px',
                      border: 'none',
                      background: '#222',
                      color: '#fff',
                      cursor: 'pointer',
                      fontSize: isMobile ? '9px' : '12px',
                      fontWeight: '700',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: isMobile ? '3px' : '6px',
                    }}
                  >
                    <FaEnvelope size={isMobile ? 16 : 22} />
                    Contact
                  </motion.button>

                </div>

              </div>

            )}

            {currentPage === 13 && (

              <div
                style={{
                  height: isMobile ? '40vh' : '550px',
                  maxHeight: isMobile ? '40vh' : '580px',
                  position: 'relative',
                  overflowY: isMobile ? 'auto' : 'visible',
                  overflowX: 'hidden',
                  borderRadius: isMobile ? '15px' : '20px',
                  background: '#000',
                  paddingBottom: isMobile ? '80px' : '0',
                  WebkitOverflowScrolling: 'touch'
                }}
              >

                {/* Background Image */}
                <img
                  src={portfolio13}
                  alt="Portfolio Slide"
                  style={{
                    position: 'absolute',
                    inset: 0,
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                    objectPosition: 'center center',
                    zIndex: 0,
                    borderRadius: isMobile ? '15px' : '20px'
                  }}
                />

                {/* Top Right Circular Button */}
                <motion.button
                  onClick={() =>
                    window.open(
                      'https://peregrinee.com',
                      '_blank',
                      'noopener,noreferrer'
                    )
                  }
                  whileHover={{
                    scale: 1.1,
                    rotate: 45,
                    boxShadow: '0 0 20px rgba(255,255,255,0.3)'
                  }}
                  whileTap={{
                    scale: 0.95
                  }}
                  style={{
                    position: 'absolute',
                    top: isMobile ? '10px' : '15px',
                    right: isMobile ? '10px' : '15px',
                    width: isMobile ? '42px' : '55px',
                    height: isMobile ? '42px' : '55px',
                    borderRadius: '50%',
                    border: 'none',
                    background:
                      'linear-gradient(135deg,#ff4d8d,#c44dff)',
                    color: '#fff',
                    fontSize: isMobile ? '18px' : '24px',
                    cursor: 'pointer',
                    fontWeight: 'bold',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 10
                  }}
                >
                  <FaArrowUp size={isMobile ? 16 : 20} />
                </motion.button>

                {/* Right Sticky Buttons */}
                <div
                  style={{
                    position: 'absolute',
                    right: isMobile ? '50%' : '-85px',
                    bottom: isMobile ? '10px' : 'auto',
                    top: isMobile ? 'auto' : '50%',
                    transform: isMobile
                      ? 'translateX(50%)'
                      : 'translateY(-50%)',
                    display: 'flex',
                    flexDirection: isMobile ? 'row' : 'column',
                    gap: isMobile ? '8px' : '12px',
                    zIndex: 20
                  }}
                >

                  <motion.button
                    onClick={() =>
                      window.open(
                        'https://peregrinee.com',
                        '_blank',
                        'noopener,noreferrer'
                      )
                    }
                    whileHover={{
                      scale: 1.08,
                      x: isMobile ? 0 : -5
                    }}
                    style={{
                      width: isMobile ? '55px' : '70px',
                      height: isMobile ? '55px' : '70px',
                      borderRadius: isMobile ? '14px' : '18px',
                      border: 'none',
                      background: '#222',
                      color: '#fff',
                      cursor: 'pointer',
                      fontSize: isMobile ? '9px' : '12px',
                      fontWeight: '700',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: isMobile ? '3px' : '6px',
                    }}
                  >
                    <FaHome size={isMobile ? 16 : 22} />
                    Home
                  </motion.button>

                  <motion.button
                    onClick={() =>
                      window.open(
                        'https://www.peregrinee.com/case-studies',
                        '_blank',
                        'noopener,noreferrer'
                      )
                    }
                    whileHover={{
                      scale: 1.08,
                      x: isMobile ? 0 : -5
                    }}
                    style={{
                      width: isMobile ? '55px' : '70px',
                      height: isMobile ? '55px' : '70px',
                      borderRadius: isMobile ? '14px' : '18px',
                      border: 'none',
                      background: '#222',
                      color: '#fff',
                      cursor: 'pointer',
                      fontSize: isMobile ? '9px' : '12px',
                      fontWeight: '700',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: isMobile ? '3px' : '6px',
                    }}
                  >
                    <FaFolderOpen size={isMobile ? 16 : 22} />
                    Work
                  </motion.button>

                  <motion.button
                    onClick={() =>
                      window.open(
                        'https://www.peregrinee.com/contact-us',
                        '_blank',
                        'noopener,noreferrer'
                      )
                    }
                    whileHover={{
                      scale: 1.08,
                      x: isMobile ? 0 : -5
                    }}
                    style={{
                      width: isMobile ? '55px' : '70px',
                      height: isMobile ? '55px' : '70px',
                      borderRadius: isMobile ? '14px' : '18px',
                      border: 'none',
                      background: '#222',
                      color: '#fff',
                      cursor: 'pointer',
                      fontSize: isMobile ? '9px' : '12px',
                      fontWeight: '700',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: isMobile ? '3px' : '6px',
                    }}
                  >
                    <FaEnvelope size={isMobile ? 16 : 22} />
                    Contact
                  </motion.button>

                </div>

              </div>

            )}




            {currentPage === 14 && (

              <div
                style={{
                  height: isMobile ? '40vh' : '550px',
                  maxHeight: isMobile ? '40vh' : '550px',
                  position: 'relative',
                  overflowY: isMobile ? 'auto' : 'visible',
                  overflowX: 'hidden',
                  borderRadius: isMobile ? '15px' : '20px',
                  background: '#000',
                  paddingBottom: isMobile ? '80px' : '0',
                  WebkitOverflowScrolling: 'touch'
                }}
              >

                {/* Background Image */}
                <img
                  src={portfolio8}
                  alt="Portfolio Slide"
                  style={{
                    position: 'absolute',
                    inset: 0,
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                    objectPosition: 'center center',
                    zIndex: 0,
                    borderRadius: isMobile ? '15px' : '20px'
                  }}
                />

                {/* Top Right Circular Button */}
                <motion.button
                  onClick={() =>
                    window.open(
                      'https://peregrinee.com',
                      '_blank',
                      'noopener,noreferrer'
                    )
                  }
                  whileHover={{
                    scale: 1.1,
                    rotate: 45,
                    boxShadow: '0 0 20px rgba(255,255,255,0.3)'
                  }}
                  whileTap={{
                    scale: 0.95
                  }}
                  style={{
                    position: 'absolute',
                    top: isMobile ? '10px' : '15px',
                    right: isMobile ? '10px' : '15px',
                    width: isMobile ? '42px' : '55px',
                    height: isMobile ? '42px' : '55px',
                    borderRadius: '50%',
                    border: 'none',
                    background:
                      'linear-gradient(135deg,#ff4d8d,#c44dff)',
                    color: '#fff',
                    fontSize: isMobile ? '18px' : '24px',
                    cursor: 'pointer',
                    fontWeight: 'bold',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 10
                  }}
                >
                  <FaArrowUp size={isMobile ? 16 : 20} />
                </motion.button>

                {/* Right Sticky Buttons */}
                <div
                  style={{
                    position: 'absolute',
                    right: isMobile ? '50%' : '-85px',
                    bottom: isMobile ? '10px' : 'auto',
                    top: isMobile ? 'auto' : '50%',
                    transform: isMobile
                      ? 'translateX(50%)'
                      : 'translateY(-50%)',
                    display: 'flex',
                    flexDirection: isMobile ? 'row' : 'column',
                    gap: isMobile ? '8px' : '12px',
                    zIndex: 20
                  }}
                >

                  {/* Home */}
                  <motion.button
                    onClick={() =>
                      window.open(
                        'https://peregrinee.com',
                        '_blank',
                        'noopener,noreferrer'
                      )
                    }
                    whileHover={{
                      scale: 1.08,
                      x: isMobile ? 0 : -5
                    }}
                    style={{
                      width: isMobile ? '55px' : '70px',
                      height: isMobile ? '55px' : '70px',
                      borderRadius: isMobile ? '14px' : '18px',
                      border: 'none',
                      background: '#222',
                      color: '#fff',
                      cursor: 'pointer',
                      fontSize: isMobile ? '9px' : '12px',
                      fontWeight: '700',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: isMobile ? '3px' : '6px',
                    }}
                  >
                    <FaHome size={isMobile ? 16 : 22} />
                    Home
                  </motion.button>

                  {/* Work */}
                  <motion.button
                    onClick={() =>
                      window.open(
                        'https://www.peregrinee.com/case-studies',
                        '_blank',
                        'noopener,noreferrer'
                      )
                    }
                    whileHover={{
                      scale: 1.08,
                      x: isMobile ? 0 : -5
                    }}
                    style={{
                      width: isMobile ? '55px' : '70px',
                      height: isMobile ? '55px' : '70px',
                      borderRadius: isMobile ? '14px' : '18px',
                      border: 'none',
                      background: '#222',
                      color: '#fff',
                      cursor: 'pointer',
                      fontSize: isMobile ? '9px' : '12px',
                      fontWeight: '700',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: isMobile ? '3px' : '6px',
                    }}
                  >
                    <FaFolderOpen size={isMobile ? 16 : 22} />
                    Work
                  </motion.button>

                  {/* Contact */}
                  <motion.button
                    onClick={() =>
                      window.open(
                        'https://www.peregrinee.com/contact-us',
                        '_blank',
                        'noopener,noreferrer'
                      )
                    }
                    whileHover={{
                      scale: 1.08,
                      x: isMobile ? 0 : -5
                    }}
                    style={{
                      width: isMobile ? '55px' : '70px',
                      height: isMobile ? '55px' : '70px',
                      borderRadius: isMobile ? '14px' : '18px',
                      border: 'none',
                      background: '#222',
                      color: '#fff',
                      cursor: 'pointer',
                      fontSize: isMobile ? '9px' : '12px',
                      fontWeight: '700',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: isMobile ? '3px' : '6px',
                    }}
                  >
                    <FaEnvelope size={isMobile ? 16 : 22} />
                    Contact
                  </motion.button>

                </div>

              </div>

            )}


          </div>


          {/* Right Click Zone */}
          <div
            onClick={() => {
              if (currentPage < 14) {
                setCurrentPage(currentPage + 1);
              }
            }}
            style={{
              position: 'absolute',

              right: isMobile ? 'calc(50% - 70px)' : 0,
              top: isMobile ? 'auto' : 0,
              bottom: isMobile ? '20px' : 'auto',

              width: isMobile ? '60px' : '17.5%',
              height: isMobile ? '60px' : '100%',

              cursor: currentPage < 14 ? 'pointer' : 'not-allowed',
              zIndex: 100,

              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <div
              style={{
                width: '60px',
                height: '60px',
                borderRadius: '50%',
                background: currentPage < 14
                  ? 'linear-gradient(135deg, #275E76 0%, #4A90A4 100%)'
                  : 'rgba(255,255,255,0.05)',
                backdropFilter: 'blur(5px)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
                transition: 'all 0.3s ease',
              }}
            >
              <FaArrowRight
                style={{
                  color: currentPage < 14 ? '#fff' : '#999',
                  fontSize: '22px',
                }}
              />
            </div>
          </div>

        </section>
      </section>



    </div >
  );
}

export default Portfolio;